import { ChangeDetectionStrategy, Component, EventEmitter, Input, Optional, Output, SkipSelf } from '@angular/core';
import { ControlContainer, FormGroup } from '@angular/forms';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';

export const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'DD/MM/YYYY',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-generic-datepicker',
  templateUrl: './generic-datepicker.component.html',
  styleUrl: './generic-datepicker.component.scss',
  changeDetection: ChangeDetectionStrategy.Default,
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { strict: true } }
  ],
})
export class GenericDatepickerComponent {

  @Input() formGroup!: FormGroup;
  @Input() controlName!: string;
  @Input() label!: string;
  @Input() placeholder: string = '';
  @Input() width: string = '100%';
  @Input() isStartDate: boolean = false; 
  @Input() isEndDate: boolean = false; 
  @Input() readonly: boolean = false; 
  @Input() minDate?: Date;
  @Input() maxDate?: Date;
  @Input() value?: Date;
  @Output() dateChanged = new EventEmitter<Date>();

  handleDateChange(event: any) {
    this.dateChanged.emit(event.value);
  }
}
